<ng-progress />

@if (languages$ | async) {
    <div class="layout">
        <ui-skip-link />
        <router-outlet name="header" />
        <router-outlet name="navbar" />

        <main [attr.id]="mainContentId">
            <router-outlet />
        </main>
        <div class="layout__footer mt-auto">
            <router-outlet name="footer" />
        </div>
        <router-outlet name="cookie-message" />
    </div>
} @else {
    <ui-pre-loader />
}
